module.exports = __webpack_public_path__ + "media/bootstrap-icons/vector-pen-f169986b.svg";